/**
 * @readonly
 * @enum {string}
 */
export const STL_OPTIONS = {
    defaultFileName: '',
    upperFileName: 'Upper',
    lowerFileName: 'Lower',
    biteOneFileName: 'Bite1',
    biteTwoFileName: 'Bite2',
};

export const defaultFileName = '';
export const upperFileName = 'Upper';
export const lowerFileName = 'Lower';
export const biteOneFileName = 'Bite1';
export const biteTwoFileName = 'Bite2';

export const stlTypeOptions = [
    {
        text: STL_OPTIONS.defaultFileName,
        value: STL_OPTIONS.defaultFileName,
    },
    {
        text: STL_OPTIONS.upperFileName,
        value: STL_OPTIONS.upperFileName,
    },
    {
        text: STL_OPTIONS.lowerFileName,
        value: STL_OPTIONS.lowerFileName,
    },
    {
        text: STL_OPTIONS.biteOneFileName,
        value: STL_OPTIONS.biteOneFileName,
    },
    {
        text: STL_OPTIONS.biteTwoFileName,
        value: STL_OPTIONS.biteTwoFileName,
    },
];
